/**
=========================================================
* Soft UI Dashboard PRO React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { forwardRef, useMemo } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// react-select components
import Select, { components } from "react-select";
import CreatableSelect from "react-select/creatable";

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";

// Custom styles for SuiSelect
import styles from "components/SuiSelect/styles";
import Tooltip from "@mui/material/Tooltip";
import SuiBox from "components/SuiBox";

const SuiSelect = forwardRef(
  ({ size, error, success, isMulti, isCreatable, sx, handleTagClick, ...rest }, ref) => {
    const { light } = colors;

    const MultiValueLabel = (props) => {
      return (
        <div onClick={(e) => handleTagClick(e, props?.data)}>
          <components.MultiValueLabel {...props} />
        </div>
      );
    };

    return isCreatable ? (
      <CreatableSelect
        isClearable
        ref={ref}
        styles={{
          ...styles(size, error, success, sx),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        components={{ MultiValueLabel: MultiValueLabel }}
        isMulti={isMulti ? true : false}
        menuPortalTarget={document.body}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: light.main,
            primary: light.main,
          },
        })}
        {...rest}
      />
    ) : (
      <Select
        ref={ref}
        styles={{
          ...styles(size, error, success, sx),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        isMulti={isMulti ? true : false}
        menuPortalTarget={document.body}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: light.main,
            primary: light.main,
          },
        })}
        {...rest}
      />
    );
  }
);

// Setting default values for the props of SuiSelect
SuiSelect.defaultProps = {
  isMulti: false,
  size: "medium",
  error: false,
  success: false,
};

// Typechecking props for the SuiSelect
SuiSelect.propTypes = {
  isMulti: PropTypes.bool,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  error: PropTypes.bool,
  success: PropTypes.bool,
};

export default SuiSelect;
